import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

const OrderConfirmation = ({ orderSuccessData }) => {

    const qrcode = orderSuccessData?.qrcode || "https://via.placeholder.com/150"; // Default placeholder if QR code is missing
    const orderId = orderSuccessData?.order_id || "N/A";
    const orderDate = orderSuccessData?.order_date || "N/A";
    const orderAmount = orderSuccessData?.order_amount || "N/A";
    const navigate = useNavigate();

    const handleReturnBack = () => {
        navigate("/"); // Adjust this route as needed
    };

    return (
        <div className="row justify-content-center">
            <div className="col-md-12">
                <div className="card shadow-lg border-0">
                    <div className="card-body text-center">
                        <div className="mb-4 p-3" style={{ backgroundColor: "#e20e75", borderRadius: "8px" }}>
                            <h4 className="text-white mb-0">Thank You!</h4>
                            <p className="text-white" style={{ textAlign: "center" }}>Your Order has been received!</p>
                        </div>

                        <p className="mb-3" style={{ fontWeight: "500", fontSize: "1.1rem", textAlign: "center" }}>Please scan the QR code below:</p>
                        <div className="d-flex justify-content-center mb-4">
                            <img
                                src={qrcode}
                                alt="QR Code"
                                className="rounded"
                                style={{ border: "2px solid #e20e75" , padding:"10px" }}
                            />
                        </div>
                        <div className="table-responsive mb-4">
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <th className="bg-light text-dark" style={{ width: "50%" }}>
                                            Order ID
                                        </th>
                                        <td>{orderId}</td>
                                    </tr>
                                    <tr>
                                        <th className="bg-light text-dark">Order Date</th>
                                        <td>{orderDate}</td>
                                    </tr>
                                    <tr>
                                        <th className="bg-light text-dark">Order Amount</th>
                                        <td>{orderAmount !== "N/A" ? `AUD ${orderAmount}` : "N/A"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* <button
                                className="btn text-white"
                                style={{ backgroundColor: "#e20e75", borderRadius: "25px", padding: "10px 20px" }}
                                onClick={handleReturnBack}
                            >
                                Return Back
                            </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderConfirmation;
